module.exports = __webpack_public_path__ + "img/KatanXadimi-BuxchakaiDaykm.dbd43dbe.jpg";